import { Component, OnInit, Inject } from "@angular/core";
import { SideEffect, SideEffectType } from "../../../../common/models/flow.dto";
import { SideEffectData, SIDE_EFFECT_DATA_TOKEN } from "./models/types";
import { WorkOrderStatus } from "../../../../common/models/work-order.model";
import { genId } from "../../../../core/services/genId";

@Component({
    selector: "side-effect-complete-work-item",
    templateUrl: "side-effect-complete-work-item.component.html",
    standalone: false
})
export class SideEffectCompleteWorkItemComponent implements OnInit {
    sideEffect: SideEffect;

    possibleStatuses = [{ id: WorkOrderStatus.Completed, display: "Completed" },
        { id: WorkOrderStatus.ApplicationRejected, display: "Application Rejected" },
        { id: WorkOrderStatus.ApplicationApproved, display: "Application Approved" }];

    constructor(
        @Inject(SIDE_EFFECT_DATA_TOKEN) public data: SideEffectData
    ) {
        this.sideEffect = data.sideEffect;    
    }

    ngOnInit() {
        if (this.sideEffect) {
            if (!this.sideEffect.configuration) {
                this.sideEffect.configuration = { targetStatus: WorkOrderStatus.Completed };
            } else if (this.sideEffect.configuration && !this.sideEffect.configuration.targetStatus) {
                this.sideEffect.configuration.targetStatus = WorkOrderStatus.Completed;
            }
        } else {
            this.sideEffect = {
                id: genId(),
                label: "Complete Current Work Item",
                implementationType: SideEffectType.CompleteWorkItem,
                configuration: { targetStatus: WorkOrderStatus.Completed }
            } as SideEffect;
        }    
    }
}